export const cacheKeys = {
  getCompanies: 'getCompanies',
  getCompany: 'getCompany',
  createCompany: 'createCompany',
  editCompany: 'editCompany',
  deleteCompany: 'deleteCompany',
};
